import React, { useState } from "react";
import "./Navbar.css";
import { useTranslation } from "react-i18next";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { t, i18n } = useTranslation();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  // Smooth scrolling
  const handleSmoothScroll = (event, targetId) => {
    event.preventDefault(); // Estää oletuskäytöksen
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: "smooth", // Smooth scroll
        block: "start",
      });
    }
    closeMenu(); // Sulkee valikon (mobile)
  };

  // Language change handler
  const changeLang = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.lang = lng; // a11y/SEO
  };
  const current = i18n.language?.startsWith("fi") ? "fi" : "en";

  return (
    <nav className="navbar">
      <div className="nav-left">
        <div className="nav-logo">
          <p>Sauli</p>
        </div>
      </div>

      <button
        className="nav-toggle"
        onClick={toggleMenu}
        aria-label="Menu"
        aria-expanded={menuOpen}
      >
        ☰
      </button>

      {/* HUOM: väli ennen open-luokkaa */}
      <ul
        className={`nav-menu ${menuOpen ? "open" : ""}`}
        onMouseLeave={closeMenu}
      >
        <li>
          <a href="#home" onClick={(e) => handleSmoothScroll(e, "home")}>
            {t("nav.home")}
          </a>
        </li>
        <li>
          <a href="#about" onClick={(e) => handleSmoothScroll(e, "about")}>
            {t("nav.about")}
          </a>
        </li>
        <li>
          <a
            href="#portfolio"
            onClick={(e) => handleSmoothScroll(e, "portfolio")}
          >
            {t("nav.portfolio")}
          </a>
        </li>
        <li>
          <a href="#contact" onClick={(e) => handleSmoothScroll(e, "contact")}>
            {t("nav.contact")}
          </a>
        </li>

        {/* kielivalitsin */}
        <div className="lang-switcher">
          <button
            className={`lang-btn ${current === "fi" ? "active" : ""}`}
            onClick={() => changeLang("fi")}
            aria-pressed={current === "fi"}
          >
            FI
          </button>
          <button
            className={`lang-btn ${current === "en" ? "active" : ""}`}
            onClick={() => changeLang("en")}
            aria-pressed={current === "en"}
          >
            EN
          </button>
        </div>

        {/* kielivalitsin myös mobiilille valikon sisään */}
        <li className="lang-switcher-mobile">
          <button
            className={`lang-btn ${current === "fi" ? "active" : ""}`}
            onClick={() => changeLang("fi")}
          >
            FI
          </button>
          <button
            className={`lang-btn ${current === "en" ? "active" : ""}`}
            onClick={() => changeLang("en")}
          >
            EN
          </button>
        </li>
      </ul>
      {/* <div className="nav-connect">Connect With Me</div> */}
    </nav>
  );
};

export default Navbar;
